module.exports = __webpack_public_path__ + "static/img/mandala.980cde4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mandala.svg
// module id = 385
// module chunks = 0 5